export default __webpack_public_path__ + "static/about-title-378ff6564f3fc28c7ef1cb2cd5294509.png";